module.exports = "<div class=sb-view-context> <div ng-transclude></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-context/page-context.html
// module id = 219
// module chunks = 0